var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.125C10.337 4.125 4.125 10.337 4.125 18C4.125 25.663 10.337 31.875 18 31.875C25.663 31.875 31.875 25.663 31.875 18C31.875 10.337 25.663 4.125 18 4.125ZM1.875 18C1.875 9.09441 9.09441 1.875 18 1.875C26.9056 1.875 34.125 9.09441 34.125 18C34.125 26.9056 26.9056 34.125 18 34.125C9.09441 34.125 1.875 26.9056 1.875 18ZM16 20.625C14.4122 20.625 13.125 21.9122 13.125 23.5C13.125 23.9832 13.5168 24.375 14 24.375H22C22.4832 24.375 22.875 23.9832 22.875 23.5C22.875 21.9122 21.5878 20.625 20 20.625H16ZM10.875 23.5C10.875 20.6695 13.1695 18.375 16 18.375H20C22.8305 18.375 25.125 20.6695 25.125 23.5C25.125 25.2259 23.7259 26.625 22 26.625H14C12.2741 26.625 10.875 25.2259 10.875 23.5ZM16.125 12C16.125 10.9645 16.9645 10.125 18 10.125C19.0355 10.125 19.875 10.9645 19.875 12C19.875 13.0355 19.0355 13.875 18 13.875C16.9645 13.875 16.125 13.0355 16.125 12ZM18 7.875C15.7218 7.875 13.875 9.72183 13.875 12C13.875 14.2782 15.7218 16.125 18 16.125C20.2782 16.125 22.125 14.2782 22.125 12C22.125 9.72183 20.2782 7.875 18 7.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0f46b26c6aa04ad5d16a7934add8a87e.svg";
export { ForwardRef as ReactComponent };